/**
 * Whether the JoySam app hosting this page keeps the WebView clear of the
 * system bars by itself.
 *
 * App builds from 2026-09 on pad the WebView by the real safe-area inset and
 * announce it by injecting `window.__JOYSAM_APP_INSETS__` before the page
 * loads. Older builds pad by a hardcoded 30dp — less than the 48dp a 3-button
 * navigation bar takes — so a fixed bottom element sits partly under that bar
 * unless the page lifts it. They inject nothing, and that absence is what
 * keeps the legacy correction alive for them and only them.
 *
 * Call it from an effect, not during render: the marker is set on `window`, so
 * reading it while rendering on the server would always say false.
 */
export type AppInsets = { top: number; bottom: number };

export const getAppInsets = (): AppInsets | null => {
    if (typeof window === 'undefined') return null;
    const insets = (window as Window & { __JOYSAM_APP_INSETS__?: AppInsets }).__JOYSAM_APP_INSETS__;
    return insets && typeof insets.bottom === 'number' ? insets : null;
};

export const appHandlesSafeArea = (): boolean => getAppInsets() !== null;
